@if (maintenanceNotice.isLockedOut()) {
  <app-maintenance-lockdown />
} @else {
  <div class="app-layout">
    <app-development-context-hud />
    <app-app-update-banner />
    <app-maintenance-banner />
    <div class="app-layout__body">
      <aside
        class="app-sidebar app-tone-bg-surface"
        [class.app-sidebar--open]="sidebarOpen()"
        [class.app-sidebar--opportunity-context]="activeOpportunity()"
        role="complementary"
        aria-label="App navigation"
      >
        <div class="app-sidebar__main">
          <div class="app-sidebar__global">
            <a
              class="app-sidebar__brand"
              routerLink="/"
              aria-label="Momentum home"
              (click)="closeSidebar()"
            >
              <div
                class="app-sidebar__logo"
                [class.app-sidebar__logo--mark-only]="activeOpportunity()"
              >
                <img
                  class="app-sidebar__brand-mark"
                  src="/Zuehlke_Logo_withoutClaim_rgb.png"
                  width="48"
                  height="48"
                  [attr.alt]="activeOpportunity() ? 'Zühlke' : ''"
                  [attr.aria-hidden]="activeOpportunity() ? null : true"
                />
                <span
                  class="app-sidebar__app-name app-type-title-md app-tone-text-secondary"
                  [attr.aria-hidden]="activeOpportunity() ? true : null"
                  >Momentum</span
                >
              </div>
            </a>

            <nav class="app-sidebar__nav" aria-label="Main navigation">
              <ul class="app-sidebar__links" role="list">
                <li>
                  <span
                    class="app-sidebar__link app-sidebar__link--disabled app-type-nav app-tone-text-muted"
                    aria-disabled="true"
                    title="Dashboard — coming soon"
                  >
                    <span class="pi pi-th-large" aria-hidden="true"></span>
                    <span class="app-sidebar__link-label">Dashboard</span>
                  </span>
                </li>
                <li>
                  <a
                    routerLink="/opportunities"
                    routerLinkActive="app-sidebar__link--active"
                    class="app-sidebar__link app-type-nav app-tone-text-muted"
                    title="Opportunities"
                    (click)="closeSidebar()"
                  >
                    <span class="pi pi-folder" aria-hidden="true"></span>
                    <span class="app-sidebar__link-label">Opportunities</span>
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/knowledge"
                    routerLinkActive="app-sidebar__link--active"
                    class="app-sidebar__link app-type-nav app-tone-text-muted"
                    title="Knowledge Library"
                    (click)="closeSidebar()"
                  >
                    <span class="pi pi-book" aria-hidden="true"></span>
                    <span class="app-sidebar__link-label">Knowledge Library</span>
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/assets"
                    routerLinkActive="app-sidebar__link--active"
                    class="app-sidebar__link app-type-nav app-tone-text-muted"
                    title="Asset Library"
                    (click)="closeSidebar()"
                  >
                    <span class="pi pi-box" aria-hidden="true"></span>
                    <span class="app-sidebar__link-label">Asset Library</span>
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/accounts"
                    routerLinkActive="app-sidebar__link--active"
                    class="app-sidebar__link app-type-nav app-tone-text-muted"
                    title="Accounts"
                    (click)="closeSidebar()"
                  >
                    <span class="pi pi-building" aria-hidden="true"></span>
                    <span class="app-sidebar__link-label">Accounts</span>
                  </a>
                </li>
              </ul>
            </nav>

            <app-sidebar-user [avatarOnly]="!!activeOpportunity()" />
          </div>

          <div
            class="app-sidebar__opportunity app-tone-bg-surface"
            [attr.aria-hidden]="!activeOpportunity()"
          >
            @if (activeOpportunity(); as activeOpportunity) {
              <app-opportunity-context-nav [opportunity]="activeOpportunity" />
            }
          </div>
        </div>
      </aside>

      <div
        class="app-sidebar-overlay"
        [class.app-sidebar-overlay--visible]="sidebarOpen()"
        (click)="closeSidebar()"
        role="button"
        tabindex="-1"
        aria-label="Close menu"
        [attr.aria-hidden]="!sidebarOpen()"
      ></div>

      <main class="app-main" id="main-content" role="main">
        <header class="app-main__mobile-header app-tone-bg-surface">
          <button
            type="button"
            class="app-main__menu-btn"
            (click)="toggleSidebar()"
            [attr.aria-expanded]="sidebarOpen()"
            aria-label="Toggle menu"
            aria-controls="main-content"
          >
            <span class="pi pi-bars" aria-hidden="true"></span>
          </button>
          <span class="app-main__mobile-title app-type-title-md app-tone-text-secondary"
            >Momentum</span
          >
        </header>
        <div class="app-main__content">
          <router-outlet />
        </div>
      </main>
    </div>
  </div>
}
